import { Injectable } from '@angular/core';
import { CrudService } from './crud.service';

@Injectable({ providedIn: 'root' })
export class SaldoVendedorService {
  constructor(private crud: CrudService) {}

  getMyBalance() {
    return this.crud.getData('saldo-vendedor/me');
  }

  requestWithdrawal(valor: number, metodoRecebimento: string) {
    return this.crud.postData('saldo-vendedor/saque', '', { valor, metodoRecebimento });
  }

  listMyWithdrawals() {
    return this.crud.getData('saldo-vendedor/saques');
  }
}
